module.exports = __webpack_public_path__ + "static/media/img_9.b2bfa076.png";